import React, { useState, useEffect } from "react";
import SavedGamesManager from "../components/SavedGamesManager";

const GameHazari = () => {
  const [players, setPlayers] = useState([
    { name: "Player 1", score: 0, history: [] },
    { name: "Player 2", score: 0, history: [] },
    { name: "Player 3", score: 0, history: [] },
    { name: "Player 4", score: 0, history: [] },
  ]);
  const [currentScores, setCurrentScores] = useState(players.map(() => ""));
  const [gameOver, setGameOver] = useState(false);
  const [isNavigatingAway, setIsNavigatingAway] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null); // Track the currently edited player index.

  const handleInputChange = (index, value) => {
    const updatedScores = [...currentScores];
    updatedScores[index] = value;
    setCurrentScores(updatedScores);

  };

  const handleSubmit = (index) => {
  const value = parseInt(currentScores[index], 10);
  if (isNaN(value)) return;

  const updatedPlayers = [...players];

  const player = { ...updatedPlayers[index] };
  player.history = [...player.history, value];
  player.score = player.score + value;

  updatedPlayers[index] = player;

  setPlayers(updatedPlayers); 

  const updatedScores = [...currentScores];
  updatedScores[index] = "";
  setCurrentScores(updatedScores);

  if (player.score >= 1000) {
    alert(`${player.name} has won the game with ${player.score} points!`);
    setGameOver(true);
  }
};



  
    // Clear saved games from localStorage when the game ends
  useEffect(() => {
    if (gameOver) {
      localStorage.removeItem("hazariSavedGames");
    }
  }, [gameOver]);

  // Players Name formating like Upper latter and lower
  const formatName = (name) => {
    return name 
    .toLowerCase()
    .trim()
    .split(" ")
    .filter(word => word !== "") //remove extra spaces;
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  };

    const updateName = (index, newName) => {
      if (newName.trim() !== "") {
        const formattedName = formatName(newName);
        
        const updatedPlayers = [...players];
        updatedPlayers[index].name = formattedName;
        setPlayers(updatedPlayers);
      }
      setEditingIndex(null); // Exit editing mode
    };


  const loadGameFromSaved = (loadedPlayers) => {
    setPlayers(loadedPlayers);
    setCurrentScores(loadedPlayers.map(() => ""));
    setGameOver(false);
  };

  // Detect Back/Forward Navigation (popstate)
  useEffect(() => {
    const handlePopState = (e) => {
      if (isNavigatingAway) return;

      const confirmNavigation = window.confirm(
        "Warning: You are about to leave the current game. Unsaved data will be lost. Save the game before navigating?"
      );
      if (!confirmNavigation) {
        // Push the current state back onto the stack to cancel navigation
        window.history.pushState(null, "", window.location.href);
      } else {
        setIsNavigatingAway(true);
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [isNavigatingAway]);

  // Warn on Page Refresh or Navigation (beforeunload)
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = ""; // Some browsers require this for the warning dialog to appear
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  //for the total score of each round shown the below
  const totalCurrentScore = currentScores.reduce((total, score) => {
    return total + (parseInt(score) || 0);
  }, 0);

  return (
    <div className="container mx-auto p-4 bg-white rounded-lg shadow-lg">
      <h1 className="text-4xl font-bold mb-6 text-center text-blue-700">
        Hazari or 360 Game Score Board
      </h1>

      <div className="space-y-4 transition-all duration-1000">
        {players.map((player, index) => (
          <div key={index} className="bg-gray-50 p-4 rounded-lg shadow transition-transform duration-1000 ease-in-out">
            <div className="flex justify-between items-center">
            {editingIndex === index ? (
                <input
                  type="text"
                  className="border px-2 py-1 rounded w-32"
                  placeholder={player.name} // Placeholder shows the current name.
                  onBlur={(e) => updateName(index, e.target.value)} // Update the name on losing focus.
                  autoFocus
                />
              ) : (
                <span
                  className="text-lg font-medium cursor-pointer underline"
                  onClick={() => setEditingIndex(index)} // Enter editing mode.
                >
                  {player.name}
                </span>
              )}
              <span className="text-lg font-bold text-green-600">
                Subtotal: {player.score}
              </span>
              <div className="flex space-x-2">
                <input
                  type="number"
                  autoCapitalize = "words"
                  placeholder="Score"
                  className="border px-1 py-0.5 rounded w-20"
                  value={currentScores[index]}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                />
                <button
                  onClick={() => handleSubmit(index)}
                  className="bg-blue-500 text-white px-2 py-1 rounded"
                >
                  Submit
                </button>
              </div>
            </div>
            <details className="mt-2">
              <summary className="cursor-pointer text-blue-500">
                View Score History
              </summary>
              <ul className="list-disc pl-5 mt-2 text-gray-700">
                {player.history.length > 0 ? (
                  player.history.map((round, roundIndex) => (
                    <li key={roundIndex}>
                      Round {roundIndex + 1}: {round} points
                    </li>
                  ))
                ) : (
                  <li>No history available</li>
                )}
              </ul>
            </details>
          </div>
        ))}
      </div>

      {gameOver && (
        <div className="text-center mt-6 text-2xl text-red-600 font-bold">
          Game Over! 🎉
        </div>
      )}

    {/* <SavedGamesManager players={players} onLoadGame={loadGameFromSaved} /> */}

      <div className="mt-6 flex items-center justify-between gap-4">

            {/* Save Button Section */}
            <div className="flex-1">
              <SavedGamesManager 
                players={players} 
                onLoadGame={loadGameFromSaved} 
              />
            </div>
          
            {/* Total Score Glass Box */}
            <div className="min-w-[120px] text-center px-4 py-2 rounded-xl border-2 border-blue-400
              bg-white/30 backdrop-blur-md shadow-md">
          
              <p className="text-xs text-gray-600">Total</p>
          
              <p className={`text-xl font-bold ${
                totalCurrentScore === 360 ? "text-green-600" : "text-red-500"
              }`}>
                {totalCurrentScore}
              </p>
            </div>
          </div>
      
    </div>

    

  );
};

export default GameHazari;
